import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { IdProps } from '../../../types/IdProps';
import AddPriceTranchePopup from '../Popups/PriceTrancheType_popup_AddPriceTranche';
import EditPriceTranchePopup from '../Popups/PriceTrancheType_popup_EditPriceTranche';

const PriceTrancheType_tab_Volumes: React.FC<IdProps> = ({ id }) => {
    const [data, setData] = useState<[]>()
    const [showAddPopup, setShowAddPopup] = useState<boolean>(false)
    const [showEditPopup, setShowEditPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications()
    const { isAuthorizedFor } = useAuth()
    const [selectedId, setSelectedId] = useState(0)

    useEffect(() => {
        getTableData();
    }, [id]);

    function getTableData() {
        DataService.get<[]>('api/v1/PriceTranches/ByPriceTrancheType/' + id)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function editRow(rowData) {
        setSelectedId(rowData.id);
        setShowEditPopup(true)
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/PriceTranches/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    let colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'From', dataProp: 'quantityFrom', dataType: 'number', align: 'right', sort: 'asc' },
        { title: 'To', dataProp: 'quantityTo', dataType: 'number', align: 'right' },
        { title: 'Begin', dataProp: 'beginDate', dataType: 'date' },
        { title: 'End', dataProp: 'endDate', dataType: 'date' },
    ];
    if (isAuthorizedFor(ApplicationFunctions.EditProductCategory)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowAddPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtPriceTranchesForPriceTrancheType'
                colInfos={colInfos}
                tableData={data}
                onRowClick={editRow}
            />
            {showAddPopup && <AddPriceTranchePopup show={showAddPopup} onHide={() => { setShowAddPopup(false); getTableData(); }} priceTrancheTypeId={id} />}
            {showEditPopup && <EditPriceTranchePopup show={showEditPopup} onHide={() => { setShowEditPopup(false); getTableData(); }} priceTrancheId={selectedId} />}
        </>
    );
}
export default PriceTrancheType_tab_Volumes;